import clsx from "clsx";
import React, { ReactNode } from "react";

export interface PageProps {
	id?: string;
	className?: string;
	children?: ReactNode;
}

const Page = (props: PageProps) => {
	const { id, children, className } = props;

	return (
		<div className={clsx("Page", id, className)} id={id}>
			{children}
		</div>
	);
};

export default React.memo(Page);
